<template>
  <v-dialog v-model="dialog" :width="qrCodeViewer ? 500 : 1500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="border-btn mr-2 align-center justify-center d-flex"
        width="120"
        height="30"
        v-bind="attrs"
        v-on="on"
      >
        <img src="/static/btn/edit.png" class="mr-1" />
        <span class="border-text ">직접입력</span>
      </v-btn>
    </template>
    <v-card v-if="materialList" class="border-white">
      <v-card-title
        class="text-h5  lighten-2 back-556C96 text-center justify-center align-center"
      >
        <h4 class="color-white">
          신규 출고 등록
        </h4>
      </v-card-title>
      <v-row class="pa-0 ma-0 " v-if="orderInvoiceStatus">
        <div class="ml-5 pt-5 width-150">
          <v-select
            solo
            flat
            dense
            :items="stateList"
            v-model="status"
            class="border-aaaaaa height-41 "
            :menu-props="{ offsetY: true }"
          />
        </div>
        <v-spacer />
      </v-row>
      <v-row class="ma-0 pa-0 ml-3 mt-3" v-if="!qrCodeViewer">
        <span class="header-text">
          신규 출고 등록 순서 : ① 부위 클릭 → ② 전체 내역 복사·수량 클릭 → ③
          개별 내역 복사
        </span>
      </v-row>

      <div
        class="d-flex justify-space-between align-center mx-3 mt-2"
        v-if="!qrCodeViewer"
      >
        <SearchInput
          ref="searchInput"
          height="36px"
          @on-search-input="onSearchInput"
          @on-reset-input="resetSearchInvoiceList"
        />

        <v-checkbox
          :input-value="switchVal"
          @change="onChangeCntSwitch"
          label="일부입고 데이터 제외"
          color="#8CA9DD"
          inset
          dense
          flat
          hide-details
        ></v-checkbox>
      </div>

      <v-row class="ma-0 pa-0 ml-3 mt-2 mb-4" v-if="!qrCodeViewer">
        <h3 class="pt-2 pr-2">입고예정일</h3>
        <v-dialog ref="dialog1" v-model="receivedDateDialog" width="388px">
          <template v-slot:activator="{ on, attrs }">
            <div class="width179-height30 align-center">
              <v-text-field
                v-model="receivedDate"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details
                class="ma-0 pa-0"
                outlined
                dense
              ></v-text-field>
            </div>
          </template>

          <DefaultDatePicker
            @update:date="updateReceivedDate"
            @close:date="receivedDateDialog = false"
          />
        </v-dialog>

        <h3 class="pt-2 pr-2 pl-2">출고일</h3>
        <v-dialog ref="dialog" v-model="shippedDateDialog" width="388px">
          <template v-slot:activator="{ on, attrs }">
            <div class="width179-height30 align-center">
              <v-text-field
                v-model="shippedDate"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details
                class="ma-0 pa-0"
                outlined
                dense
              ></v-text-field>
            </div>
          </template>

          <DefaultDatePicker
            @update:date="updateShippedDate"
            @close:date="shippedDateDialog = false"
          />
        </v-dialog>

        <v-spacer />
        <h3 class="pt-2 pr-2 pl-2">송장코드</h3>

        <div class="mr-5">
          <input
            v-model="invoiceOfCode"
            style="height:40px;border:1px solid #9E9E9E;border-radius: 4px;"
          />
        </div>
      </v-row>

      <v-simple-table
        class="invoice-table mr-3 ml-3 mt-1"
        v-if="!qrCodeViewer"
        :height="invoiceList.length > 4 ? 500 : ''"
        fixed-header
      >
        <thead>
          <tr>
            <th
              :rowspan="2"
              class="text-center back-8ca9dd color-white"
              v-if="!orderInvoiceStatus"
            >
              선택
            </th>
            <th
              :rowspan="2"
              class="text-center border-left-aaaaaa back-8ca9dd color-white"
            >
              발주차수
            </th>
            <th
              :rowspan="2"
              class="text-center border-left-aaaaaa  back-8ca9dd color-white"
            >
              부위
            </th>
            <th
              :colspan="materailLength"
              class="text-center border-bottom-aaaaaa border-left-aaaaaa back-8ca9dd color-white"
            >
              규격(단위:TON)
            </th>
            <th
              :rowspan="2"
              class="text-center border-left-aaaaaa back-8ca9dd color-white"
            >
              잔여수량
            </th>
            <th
              :rowspan="2"
              class="text-center border-left-aaaaaa back-8ca9dd color-white"
            >
              출고여부
            </th>
          </tr>
          <tr>
            <th
              v-for="material in materialList"
              :key="material.rebar_id"
              class="text-center border-left-aaaaaa back-8ca9dd color-white"
            >
              {{ material.rebar_name }}
            </th>
          </tr>
        </thead>

        <template v-for="(invoice, index) in invoiceList">
          <tbody
            :key="invoice.invoiceId"
            v-if="!choiceState ? true : checkboxList[index]"
          >
          <tr>
            <td
              class="text-center justify-center  align-center border-bottom-aaaaaa border-left-aaaaaa"
              :rowspan="2"
              v-if="!orderInvoiceStatus"
            >
              <input type="checkbox" v-model="checkboxList[index]" />
            </td>
            <td
              class="text-center back-f5f5f5 border-bottom-aaaaaa border-left-aaaaaa "
              :rowspan="2"
            >
              {{ invoice.orderName }}
            </td>
            <td
              class="text-center  back-f5f5f5 border-aaaaaa cursor-pointer"
              :rowspan="2"
              @click="listFill(invoice.regacyInvoiceSumList, index, -1)"
            >
              {{ invoice.partName }}
            </td>
            <td
              v-for="(invoiceValue, i) in invoice.regacyInvoiceSumList"
              :key="i"
              class="text-right pr-1 border-bottom-aaaaaa border-right-aaaaaa cursor-pointer"
              @click="listFill(invoice.tempList, index, i)"
            >
              {{ mathRound(invoiceValue).toFixed(3) }}
            </td>
            <td
              class="text-right pr-1 border-bottom-aaaaaa border-right-aaaaaa"
            >
              {{ mathRound(invoice.allSum).toFixed(3) }}
            </td>
            <td class="text-center border-right-aaaaaa" :rowspan="2">
              {{ invoice.orderStatus }}
            </td>
          </tr>
          <tr>
            <td
              v-for="i in materailLength"
              :key="i"
              style="width:100px !important;"
              class="text-center border-bottom-aaaaaa border-right-aaaaaa "
            >
              <input
                v-model.number="invoice.tempList[i - 1]"
                class="input-number
                              text-right pa-0 pr-1 border-aaaaaa"
                placeholder="입력"
                type="number"
                @focus="focusClear(invoice.tempList[i - 1], index, i)"
              />
            </td>
            <td
              class="border-bottom-aaaaaa border-right-aaaaaa text-right pr-1 "
            >
              {{ sum(invoice.tempList, index).toFixed(3) }}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div
        v-if="invoiceList.length === 0"
        class="d-flex justify-center py-4 grey--text"
        style="width:100%"
      >
        빈 목록 입니다.
      </div>

      <v-card-actions
        class=" align-center  justify-center pb-5 pt-5"
        v-if="!qrCodeViewer"
      >
        <v-btn
          color="#739EEC"
          class="color-white default-btn-text mr-3"
          @click="invoiceInsert"
          width="150"
          height="40"
        >
          확인
        </v-btn>
        <v-btn
          color="#EEEEEE"
          @click="dialog = false"
          width="150"
          height="40"
          class="default-btn-text"
        >
          취소
        </v-btn>
      </v-card-actions>
      <div class="justify-center  pt-5" v-if="qrCodeViewer">
        <v-row class="justify-center align-center d-flex pt-5 ma-0 pa-0">
          <h3>
            {{ "현장명 : " + constructionName.constructionName }}
          </h3>
        </v-row>
        <v-row class="justify-center align-center d-flex text-center ma-0 pa-0">
          <h4>
            출고데이터 입력이 완료 되었습니다.<br />
            QR 코드는 아래와 같습니다.
          </h4>
        </v-row>
        <v-row class="justify-center align-center d-flex ma-0 pa-0">
          <div @click="qrDownTest">
            <qr-code :text="qrCode" size="150" color="#000000"></qr-code>
          </div>
        </v-row>
        <v-row class="justify-start align-center d-flex ma-0 pl-4">
          <h3>QR코드 링크 URL :</h3>
        </v-row>
        <v-row class="justify-start align-center d-flex ma-0 pl-4">
          <a :href="qrCode">{{ qrCode }}</a>
        </v-row>
      </div>
      <v-card-actions
        class="justify-center align-center pb-8 pt-5"
        v-if="qrCodeViewer"
      >
        <v-btn
          color="#739EEC"
          class="color-white mr-3"
          v-clipboard:copy="qrCode"
          width="150"
          height="40"
        >
          QR링크 복사
        </v-btn>
        <v-btn color="#EEEEEE" @click="confirmOk" width="150" height="40">
          닫기
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InvoiceApi from "@/api/InvoiceService";
import VueQRCodeComponent from "vue-qrcode-component";
import fileDownload from "@/assets/js/file-download.js";
import qrApi from "@/api/FileService";
import Commonality from "@/mixin/Commonality";
import DefaultDatePicker from "@/components/DefaultDatePicker.vue";
import SearchInput from "@/components/SearchInput.vue";

export default {
  mixins: [Commonality],
  props: ["invoiceId", "orderId", "orderInvoiceStatus"],

  components: {
    "qr-code": VueQRCodeComponent,
    DefaultDatePicker,
    SearchInput,
  },

  data: function() {
    return {
      dialog: false,
      insertDate: "",
      materailLength: 0,
      invoiceList: [],
      checkboxList: [],
      choiceState: false,
      tableLength: 0,
      qrCode: "",
      qrCodeViewer: false,
      downCount: 0,
      status: "입고완료",
      stateList: ["입고완료", "발주완료"],
      modal: false,
      receivedDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substring(0, 10),
      shippedDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      invoiceOfCode: "",
      receivedDateDialog: false, // 입고예정캘린더 모달
      shippedDateDialog: false, // 출고예정캘린더 모달
      initInvoiceList: [],
      searchInvoiceList: [], // 검색된 목록
      switchInvoiceList: [], // 입부입고 제외 체크된 후 목록
      switchVal: true, // 일부입고 데이터 제외 여부
    };
  },

  watch: {
    async dialog(value) {
      if (value) {
        await this.reset();
        if (this.orderInvoiceStatus) this.checkboxList[0] = true;
        this.onChangeCntSwitch(this.switchVal);
      } else {
        this.qrCodeViewer = false;
        this.$refs.searchInput.onResetInput();
        this.switchVal = true;
      }
    },
  },
  async created() {
    await this.reset();
    if (this.orderInvoiceStatus) this.checkboxList[0] = true;
    this.onChangeCntSwitch(this.switchVal);
  },
  methods: {
    /** [일부입고 데이터 제외] 체크박스 반영함수 */
    onChangeCntSwitch(value) {
      this.switchVal = value;
      const 입고완료 = 0.01; // 0.01(10kg) 이상 시
      if (!value) {
        this.switchInvoiceList = [];
        if (this.searchInvoiceList?.length > 0) {
          return (this.invoiceList = this.searchInvoiceList);
        } else {
          return (this.invoiceList = this.initInvoiceList);
        }
      }

      const isFilter =
        this.searchInvoiceList?.length > 0
          ? "searchInvoiceList"
          : "initInvoiceList";

      const filtered = this[isFilter].filter((el) => {
        const itemVal = Number(this.mathRound(el.allSum));
        return 입고완료 < itemVal;
      });
      this.switchInvoiceList = filtered;
      this.invoiceList = filtered;
    },
    /** 검색인풋 이벤트핸들러 */
    onSearchInput({ type, value }) {
      if (!value?.trim() || value.length === 0) {
        return this.resetSearchInvoiceList();
      }
      const fieldList = {
        발주차수: "orderName",
        부위: "partName",
      };
      const fieldName = fieldList[type];

      const isFilter =
        this.switchInvoiceList?.length > 0
          ? "switchInvoiceList"
          : "initInvoiceList";

      const filtered = this[isFilter].filter((el) => {
        const itemVal = el[fieldName].replaceAll(" ", "");
        const inputVal = value.replaceAll(" ", "");
        if (fieldName === "partName") {
          return itemVal.includes(inputVal);
        }
        return itemVal === inputVal;
      });
      this.searchInvoiceList = filtered;
      this.invoiceList = filtered;
    },
    /** 검색목록 초기값으로 세팅 */
    resetSearchInvoiceList() {
      this.searchInvoiceList = [];
      if (this.switchVal) {
        this.invoiceList = this.switchInvoiceList;
      } else {
        this.invoiceList = this.initInvoiceList;
      }
    },
    updateReceivedDate(date) {
      this.receivedDate = date;
      this.receivedDateDialog = false;
    },
    updateShippedDate(date) {
      this.shippedDate = date;
      this.shippedDateDialog = false;
    },
    focusClear(val, index, i) {
      if (val != 0) return;
      let list = [];
      for (let j = 0; j < this.invoiceList[index].tempList.length; j++) {
        if (i - 1 != j)
          list.push(this.mathRound(this.invoiceList[index].tempList[j]));
        else list.push("");
      }
      this.invoiceList[index].tempList = list;
    },
    listFill(valList1, index, state) {
      let tempList = [];
      for (let i = 0; i < valList1.length; i++) {
        if (i != state) tempList.push(this.mathRound(valList1[i]));
        else {
          tempList.push(
            this.mathRound(this.invoiceList[index].regacyInvoiceSumList[state])
          );
        }
      }
      this.checkboxList[index] = true;
      this.invoiceList[index].tempList = tempList;
    },
    confirmOk() {
      this.dialog = !this.dialog;
      this.qrCodeViewer = !this.qrCodeViewer;
    },
    async reset() {
      let data = {
        constructionId: this.constructionId,
      };
      this.materailLength = this.materialList.length;
      let returnData = await InvoiceApi.invoiceOrderList(data);
      for (let i = 0; i < returnData.data.orderList.length; i++) {
        returnData.data.orderList[i].tempList = [];
        returnData.data.orderList[i].tempSum = 0;
        for (let j = 0; j < this.materailLength; j++) {
          returnData.data.orderList[i].tempList[j] = 0;
        }
      }
      this.invoiceList = returnData.data.orderList;
      this.initInvoiceList = returnData.data.orderList;
      this.searchInvoiceList = returnData.data.orderList;
      if (this.orderId)
        this.invoiceList = this.invoiceList.filter(
          (list) => list.orderId == this.orderId
        );
      this.tableLength = this.invoiceList.length;
      this.choiceState = false;
      this.checkboxList = [];
      this.downCount = 0;
      this.receivedDate = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.shippedDate = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
    },

    async invoiceInsert() {
      let resultData = this.checkboxList.filter(
        (checkboxValue) => checkboxValue == true
      );
      if (resultData.length == 0) {
        this.$bus.$emit("dialog", "선택 후 업로드를 진행 해주세요.");
        return;
      }
      let sendDataList = {
        invoiceData: [
          {
            oneRow: [],
          },
        ],
        constructionId: this.constructionId,
        selectDate: this.shippedDate,
        invoiceInputCode: this.invoiceOfCode,
      };
      let sum;
      let listOrder = 0;
      for (let i = 0; i < this.checkboxList.length; i++) {
        if (this.checkboxList[i]) {
          sum = 0;
          let tempList = [];
          for (let j = 0; j < this.invoiceList[i].tempList.length; j++) {
            tempList.push({
              rebarName: this.materialList[j].rebar_name,
              rebarValue:
                this.invoiceList[i].tempList[j] == ""
                  ? 0
                  : this.invoiceList[i].tempList[j],
            });
            //this.invoiceList[i].tempList[j] = this.invoiceList[i].tempList[j] == '' ? 0 : this.invoiceList[i].tempList[j]
            sum += Number(this.invoiceList[i].tempList[j]);
          }
          if (sum > 0) {
            sendDataList.invoiceData[0].oneRow[listOrder++] = {
              dueDate: this.receivedDate,
              orderId: this.invoiceList[i].orderId,
              rebarListData: tempList,
            };
          } else {
            this.$bus.$emit(
              "dialog",
              "합계가 0보다 작습니다. 확인 후 작업해세요."
            );
            return;
          }
        }
      }
      let result = await InvoiceApi.invoiceCreate(sendDataList);
      if (result.data.success == "ok") {
        this.qrCode = `${window.location.protocol}//${window.location.host}/qrCode?qrText=${result.data.resultInvoice[0].qrString}`;
        this.qrCodeViewer = true;
        this.$emit("invoiceReset");
      } else {
        this.$bus.$emit(
          "dialog",
          "다시시도 해주세요. \n 지속될 경우 관리자에게 문의해주세요."
        );
      }
    },
    async qrDownTest() {
      if (this.downCount == 0) {
        this.$bus.$emit("loadingStart");
        let data = await qrApi.qrCodeDownload({
          urlLink: this.qrCode,
        });
        fileDownload(data.data, "Qr코드.png");
        this.downCount++;
        this.$bus.$emit("loadingEnd");
      }
    },
  },
};
</script>

<style scoped>
th {
  height: 30px !important;
}
td {
  height: 30px !important;
}
.header-text {
  font-family: "Noto Sans KR";
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
}
.width-150 {
  width: 150px;
}

.height-41 {
  height: 41px;
}

.pb-8 {
  padding-bottom: 8px;
}

.input-number {
  width: 90%;
}

::v-deep
  .invoice-table.v-data-table--fixed-header
  > .v-data-table__wrapper
  > table
  > thead
  > tr:nth-child(2)
  > th {
  top: 30px;
}
</style>
